module.exports = __webpack_public_path__ + "assets/img/title.d2ac5509.png";